import { AdaptiveSheet } from '../common/AdaptiveSheet';
import { DefensePlanPartyEditForm } from './DefensePlanPartyEditForm.web';
import type { PlanParty } from '../../types';

// Phone (and any non-desktop-shell caller) host for
// DefensePlanPartyEditForm — the desktop shell puts the same form in a
// CompanionPanel instead (DefensePlanPanel.web.tsx branches on
// useDesktopShell()).
export function DefensePlanPartyEditSheet({
  visible,
  planId,
  party,
  onClose,
}: {
  visible: boolean;
  planId: string | null;
  party: PlanParty | null;
  onClose: () => void;
}) {
  return (
    <AdaptiveSheet isOpen={visible} onRequestClose={onClose} onDismiss={onClose} dialogWidth={440}>
      <AdaptiveSheet.ScrollView testID="party-edit-sheet">
        <DefensePlanPartyEditForm planId={planId} party={party} onClose={onClose} />
      </AdaptiveSheet.ScrollView>
    </AdaptiveSheet>
  );
}
